import { ComponentName } from './component-name';

export interface DynamicPageConfig {
  id: string;
  name?: string;
  components: {
    id: string;
    componentName: ComponentName;
  }[];
}
